import { GetServerSideProps, GetServerSidePropsContext } from 'next';

import { UsStateCode } from '@/__generated__/globalTypes';
import { seoSegmentationsByCityOrState_seoSegmentationsByCityOrState_SEOSegmentationsByCityOrStateSuccess_seoSegmentationsByCityOrState_linkSection as SEODirectorySection } from '@/__generated__/seoSegmentationsByCityOrState';
import { getSEOSegmentationBreadcrumbs_getSEOSegmentationBreadcrumbs_breadcrumbs as BreadcrumbsType } from '@/__generated__/getSEOSegmentationBreadcrumbs';

import { getServerSideProps as cityServicesDirectoryProps } from '@/components/pages/directories/CityServices/cityServicesDirectoryProps';
import { getServerSideProps as stateServicesDirectoryProps } from '@/components/pages/directories/StateServices/stateServicesDirectoryProps';
import CityServicesDirectory from '@/components/pages/directories/CityServices/CityServicesDirectory';
import StateServicesDirectory from '@/components/pages/directories/StateServices/StateServicesDirectory';

export type PageProps = {
  pageData: {
    breadcrumbs?: BreadcrumbsType[];
    linkSection: SEODirectorySection[];
    state: UsStateCode;
    city: string | null;
  };
  seoSegmentId: string;
  _sentryBaggage?: string;
  _sentryTraceData?: string;
};

export const getServerSideProps: GetServerSideProps = async (
  context: GetServerSidePropsContext
) => {
  // check if segment is ${city}-${state} or ${state} format
  const getDataFn = context.query.segment?.includes('-')
    ? cityServicesDirectoryProps
    : stateServicesDirectoryProps;
  return getDataFn(context);
};

export default function renderServicesListByCityOrState(pageProps: PageProps) {
  const { seoSegmentId } = pageProps;
  // split to check the last element in the array is ${city}-${state} or ${state} format:
  // e.g. ['', 'all-services', 'austin-tx'] or ['', 'all-services', 'tx']
  const segments: string[] = seoSegmentId.split('/');

  if (segments[2].includes('-')) {
    return <CityServicesDirectory props={pageProps} />;
  }

  return <StateServicesDirectory props={pageProps} />;
}
